import { render, staticRenderFns } from "./NotaPostOperatoria.vue?vue&type=template&id=da947ade&scoped=true&"
import script from "./NotaPostOperatoria.vue?vue&type=script&lang=js&"
export * from "./NotaPostOperatoria.vue?vue&type=script&lang=js&"
import style0 from "./NotaPostOperatoria.vue?vue&type=style&index=0&id=da947ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da947ade",
  null
  
)

export default component.exports